import { useEffect, useState } from 'react';
import './App.css';
import {
  Button,
  Divider,
  Flex,
  Form,
  Input,
  message,
  Switch,
  Upload,
  UploadProps,
} from 'antd';
import { Typography } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from 'react-router-dom';
import Editor from './Editor';

import COS from 'cos-js-sdk-v5';
import { LeftCircleOutlined } from '@ant-design/icons';

const { Dragger } = Upload;

const { Title } = Typography;

const MarshmallowCreate = () => {
  const [form] = Form.useForm();
  const [value, setValue] = useState('');
  const [showFiles, setShowFiles] = useState<string[]>([]);
  const n = useNavigate();
  const props: UploadProps = {
    name: 'file',
    multiple: true,
    action: 'upload',
    showUploadList: {
      extra: file => {
        return (
          <>
          <Divider type='vertical' style={{borderInlineStart: '2px solid rgba(5, 5, 5, 0.3)'}} />
            公开此附件？
            <Switch
              onChange={value => {
                if (value) {
                  setShowFiles([
                    ...showFiles,
                    file.response.Location.replace(
                      'lynne-1252518086.cos.ap-shanghai.myqcloud.com/',
                      ''
                    ),
                  ]);
                } else {
                  const newShowFiles = showFiles.filter(
                    fileName =>
                      fileName !==
                      file.response.Location.replace(
                        'lynne-1252518086.cos.ap-shanghai.myqcloud.com/',
                        ''
                      )
                  );
                  setShowFiles(newShowFiles);
                }
              }}
            />
          </>
        );
      },
    },
    async customRequest(options) {
      const cos = new COS({
        // getAuthorization 必选参数
        getAuthorization: function (options, callback) {
          const url = 'https://api.lynne.com.cn/wiki/uploadFile'; // url 替换成您自己的后端服务
          const xhr = new XMLHttpRequest();
          xhr.open('GET', url, true);
          xhr.onload = function (e) {
            let data = null;
            let credentials = null;
            try {
              data = JSON.parse((e.target as XMLHttpRequest).responseText);
              credentials = data.credentials;
            } catch (e) {}
            if (!data || !credentials) {
              return console.error(
                'credentials invalid:\n' + JSON.stringify(data, null, 2)
              );
            }
            callback({
              TmpSecretId: credentials.tmpSecretId,
              TmpSecretKey: credentials.tmpSecretKey,
              SecurityToken: credentials.sessionToken,
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
              ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000000
            });
          };
          xhr.send();
        },
      });
      cos.putObject(
        {
          Bucket: 'lynne-1252518086', // 必须
          Region: 'ap-shanghai', // 存储桶所在地域，必须字段
          Key: `file${Date.now()}-${(options.file as File).name}`, // 必须
          StorageClass: 'STANDARD',
          Body: options.file, // 上传文件对象
          onProgress: progressData => {
            const progress = {
              percent: progressData.percent * 100,
            };
            options.onProgress && options.onProgress(progress);
          },
        },
        function (err, data) {
          if (err) {
            // 处理请求出错
            console.log(err);
          } else {
            // 处理请求成功
            console.log(data);
            options.onSuccess && options.onSuccess(data);
          }
        }
      );
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        message.success(`${info.file.name} 上传成功.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} 上传失败.`);
      }
    },
  };

  const onAddMarshmallow = async (values: any) => {
    const content = values.content;
    const title = values.title;
    const files = values.files;
    let filesStr = '';
    let filesAvailableStr = '';
    if (files) {
      const nameList = files.fileList.map(
        (file: { response: { Location: string } }) => {
          return file.response.Location.replace(
            'lynne-1252518086.cos.ap-shanghai.myqcloud.com/',
            ''
          );
        }
      );
      const filesAvailableList = nameList.map((name: string) =>
        showFiles.includes(name)
      );
      filesStr = nameList.join('|');
      filesAvailableStr = filesAvailableList.join('|');
    }
    const response = await (
      await fetch('https://api.lynne.com.cn/marshmallow/create', {
        method: 'POST',
        body: JSON.stringify({
          content,
          title,
          files: filesStr,
          files_available: filesAvailableStr,
        }),
        headers: new Headers({
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'Application/json',
        }),
      })
    ).json();
    if (response.success) {
      message.success(response.message);
      n('/marshmallow/success');
    } else {
      message.error(response.message);
    }
  };
  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, []);
  // 渲染数据
  return (
    <>
      <Flex align='center' gap={10}>
        <Button
          type='primary'
          shape='circle'
          icon={<LeftCircleOutlined />}
          onClick={() => n('/marshmallow')}
        />
        <Title level={3} style={{ margin: '15px 0', flex: 1 }}>
          棉花糖投稿~
        </Title>
      </Flex>
      <Divider />
      <Form
        layout='vertical'
        form={form}
        name='new_wiki'
        clearOnDestroy
        onFinish={values => onAddMarshmallow(values)}>
        <Form.Item
          name='title'
          label='标题（不超过50字）'
          rules={[
            {
              required: true,
              message: '请输入标题（不超过50字）',
              type: 'string',
              max: 50,
            },
          ]}>
          <Input />
        </Form.Item>
        <Form.Item
          name='content'
          label='内容'
          rules={[
            {
              required: true,
              message: '请输入内容',
            },
          ]}>
          <Editor
            placeholder={'在这里输入内容喵~'}
            onChange={setValue}
            value={value}
          />
        </Form.Item>
        <Form.Item name='files' label='附件（可选，玲奈可以查看所有的（公开和非公开）附件，公开的附件其他小狐凃也可以查看）' valuePropName='file'>
          <Dragger {...props}>
            <p className='ant-upload-drag-icon'>
              <InboxOutlined />
            </p>
            <p className='ant-upload-text'>点击此处或拖动文件到此处上传</p>
            <p className='ant-upload-hint'>支持上传多个文件，玲奈可以查看所有的（公开和非公开）附件，选择公开的附件其他小狐凃也可以查看</p>
          </Dragger>
        </Form.Item>
        <Button type='primary' htmlType='submit'>
          提交
        </Button>
      </Form>
    </>
  );
};

export default MarshmallowCreate;
